import { Grid, makeStyles } from "@material-ui/core";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
import { Helmet } from "react-helmet";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import mask from "../../assets/images/mask.svg";
import hide from "../../assets/images/hide.svg";
import { Toast } from "../../components";
import AuthLayout from "../../layout/AuthLayout";
import { login } from "../../redux/auth/actions";
import axios from "../../redux/axios";
import { decrypt, encrypt } from "../../utils";
import { api, passcodeKey, tokenKey, usernameKey } from "../../utils/constants";
import "./auth.scss";
import styles from "./style";
import Dialog from '@material-ui/core/Dialog';
import Close from './../../assets/images/close.svg';
// import { notification } from 'antd';
import { getFirebaseAnalyticsInstance } from "../../firebase";
import ReactGA from 'react-ga';
import { showNotification } from "../../components/commonnotification/commonNotification"
// import {NotificationContainer, NotificationManager} from 'react-notifications';
// import { BellOutlined } from '@ant-design/icons';
import './Login.css';
import {
  Input,
  Button,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => styles(theme));

const Login = () => {
  const classes = useStyles();
  const [cookies, setCookie] = useCookies([usernameKey, passcodeKey, tokenKey]);
  const [nphone, setNphone] = useState();
  const [verified, setVerified] = useState(false);
  const [phoneerror, setPhoneerror] = useState(false);
  const [reserror, setReserror] = useState(false);
  let history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [country, setCountry] = useState(234);
  const [show, setShow] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [status, setStatus] = useState('')
  const [uuid1, setUuid1] = React.useState('')
  const [logtype, setLogtype] = React.useState('')
  const [nphone1, setNphone1] = useState();

  const addFireBaseAnalytics = async () => {
    try {
      await getFirebaseAnalyticsInstance().logEvent("USER_LOGIN", {
        eventType: "LOGIN",
        platform: "web",
      });
    } catch (error) {
      console.log(error);
    }
    ReactGA.event({
      category: 'LOGIN',
      action: 'LOGIN',
      label: 'LOGIN',
    })
  };

  useEffect(() => {
    if (!user.isAuthenticated && cookies[usernameKey] && cookies[passcodeKey]) {
      const username = decrypt(cookies[usernameKey]);
      const password = decrypt(cookies[passcodeKey]);
      const val = { username, password, type: "loginwithcredential" };
      dispatch(
        login(val, (res) => {
          localStorage.setItem("PWD", password);
          console.log("login response", res);
          addFireBaseAnalytics()
        })
      );
    }
    // alert(cookies["redirect"])
  }, [cookies]);

  useEffect(() => {
    if (user.verified === false) {
      let values = {
        email: user.email,
        mobile: user.mobile,
      };
      axios.post(api.resetpassword, values).then((res) => {
        setVerified(true);
        setTimeout(function () {
          setVerified(false);
          history.push("/confirmVerification");
        }, 4000);
      });
    } else if (user.isAuthenticated === true && user.verified === true && user.login_type !== "facebook" && user.login_type !== "google") {
      console.log("hits");
      addFireBaseAnalytics()
      history.push("/");
      localStorage.setItem("CTKN", user.token);
    }
  }, [user]);
  // useEffect(() => {
  //   fetch("https://ipapi.co/json/")
  //     .then((res) => res.json())
  //     .then((res) => {
  //       setCountry(res.country_code.toLowerCase());
  //     })
  //     .catch((data, status) => {
  //       console.log("Request failed:", data);
  //     });
  // }, []);

  useEffect(() => {
    if (user) {
      if (user.error === "Invalid username or password!") {
        setReserror(true);
        setTimeout(function () {
          setReserror(false);
        }, 2000);
      }
    }
  }, [user]);

  const handleResponseError = () => {
    if (phoneerror === false) {
      return <div className="error">''</div>;
    } else {
      return <></>;
    }
  };

  const validationSchema = Yup.object({
    Passcode: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")
    // .min(4, "Must be exactly 4 digits")
    // .max(4, "Must be exactly 4 digits")
    // .required("Required"),
  });

  const errorstyle = {
    border: reserror ? "1px solid #E04E47" : "1px solid #E3EAF6 ",

    outline: "none !important",
    borderRadius: "5px",
  };
  const errorLabel = {
    color: reserror ? "#E04E47" : "",
  };
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      Passcode: "",
    },
    validationSchema,
    onSubmit: (values) => {
      if (nphone === "" || nphone === undefined) {
        setPhoneerror(true);
      } else {
        setPhoneerror(false);
        const username = nphone;
        const password = values.Passcode.toString();
        const type = "loginwithcredential";
        const val = { username, password, type };
        dispatch(
          login(val, (res) => {
            localStorage.setItem("PWD", password);
            console.log("login response", res);
            var cipherUsername = encrypt(res.username);
            var cipherPassword = encrypt(password);
            var cipherToken = encrypt(res.token);

            const cookieOptions = {
              path: "/",
              secure: process.env.REACT_APP_COOKIE_SECURE,
              domain: process.env.REACT_APP_COOKIE_DOMAIN,
            };
            setCookie(usernameKey, cipherUsername, cookieOptions);
            setCookie(passcodeKey, cipherPassword, cookieOptions);
            setCookie(tokenKey, cipherToken, cookieOptions);
          })
        );
      }
    },
  });

  const logoutFun = () => {
    setModalShow(false)
    // dispatch(logout())
  }


  const mobileUpdate = (values) => {
    values.preventDefault();
    console.log(values)
    // let phnNum = values.target.elements.phoneNUmber.value;
    var payload = {
      "uuid": uuid1,
      "login_type": logtype,
      "mobile": nphone1
    }

    axios.post(`${process.env.REACT_APP_API_URL}/user/auth/update/facebook/google/mobile`, payload)
      .then((res) => {
        showNotification(
          "success",
          "Mobile Number Updated Successfully"
        )
        // NotificationManager.info({
        //   message: "Mobile Number Updated Successfully",
        //   description: "",
        //   // icon: <BellOutlined></BellOutlined>,
        // })
        localStorage.setItem("phoneNumber", nphone1);
        history.push("/");
      })
      .catch((err) => {
        setModalShow(false)
        showNotification("error", "Failed !!", "" + err.response.data)
        // NotificationManager.info({
        //   message: err.response.data,
        //   description: "",
        //   // icon: <BellOutlined></BellOutlined>,
        // })
      })
  }

  const responseGoogle = (response) => {
    console.log(response, "google");
    const type = "loginwithgoogle";
    var payLoad = { response, type };
    console.log(payLoad, "google");
    dispatch(login(payLoad, (res) => {
      console.log(res, "hghh")
      if (res.verified === true) {
        console.log(res.is_mobile_update, "hghh")
        if (res.is_mobile_update == false) {
          console.log("if")
          setModalShow(true)
          setStatus("google")
          setUuid1(res.uuid)
          setLogtype(res.login_type)
          showNotification("Logged in Successfully")
          // notification.info({
          //   message: "Logged in Successfully",
          //   description: "",
          //   icon: <BellOutlined style={{ color: '#108ee9' }} />,
          // })

        } else {
          console.log("ifelse")
          setModalShow(false)
          history.push("/");
        }
      }
      localStorage.setItem("CTKN", res.token);
    })
    );
  };
  const responseFacebook = (response) => {
    console.log(response, "fb");
    const type = "loginwithFb"
    var payLoad = { response, type };
    console.log(payLoad, "google")
    // dispatch(
    //   login(payLoad, (res) => {
    //   console.log(res.verified)
    //   if (res.verified === true) {
    //     history.push("/dashboard");
    //   }
    //   localStorage.setItem("CTKN", res.token);
    // })
    // );
    dispatch(login(payLoad, (res) => {
      console.log(res.verified)
      if (res.verified === true) {
        if (res.is_mobile_update === false) {
          setModalShow(true)
          setStatus("fb")
          setUuid1(res.uuid)
          setLogtype(res.login_type)
          // notification.info({
          //   message: "Logged in Successfully",
          //   description: "",
          //   icon: <BellOutlined style={{ color: '#108ee9' }} />,
          // })

        }
        else {
          setModalShow(false)
          history.push("/");
        }
      }
      localStorage.setItem("CTKN", res.token);
    })
    );
  };
  return (
    <AuthLayout>
      <Helmet>
        <title>Diagnostics.doctall.com | Login
        </title>
        <meta
          name='description'
          content='Login to shop for a wide range of tests from Diagnostic Marketplace. Get the best deals, have test results delivered to you'
        />
      </Helmet>
      <Dialog fullWidth={true} maxWidth={"sm"} open={modalShow} >

        <div className="closeButtonPopup">
          <img style={{ cursor: 'pointer' }} src={Close} onClick={() => { logoutFun() }} alt="Close" crossorigin="anonymous" />
        </div>

        <form onSubmit={mobileUpdate}>
          <label style={{ marginLeft: "20%" }}>Please Provide your Mobile Number</label>
          <center>
            <br></br>
            <PhoneInput
              style={{ width: "60%" }}
              className="inputPhone"
              country={country}
              value={nphone1}
              onChange={setNphone1}
            />
            {/* <input
            // style={errorstyle}
            className="inputForm"
            type={"number"}
            name="phoneNUmber"
            maxLength={10}
          // onChange={handleNumChange}
          // value={num}
          style={{width:"60%"}}
          /> */}
            <br></br>
            <button type="submit" className="sumbitBtn" style={{ width: "20%" }}>
              Submit
            </button>
          </center>
        </form>
      </Dialog>
      <div className="loginForm">
        <h1>Welcome Back</h1>
        <div>
          <p>Enjoy personalized healthcare and start living better</p>
          {verified === true ? (
            <>
              <div className="error">
                You Need verify first redirecting to code verification screen...
              </div>
              <Toast
                text={`Please verify your account with  Email : ${user.email} and Phone : ${user.mobile}`}
                type="warning"
                open={verified}
                setClose={() => {
                  console.log("");
                }}
              />
            </>
          ) : (
            ""
          )}
          <Toast
            text={"Invalid Phone Number / Passcode"}
            type="warning"
            open={reserror}
            setClose={() => {
              console.log("");
            }}
          />
        </div>

        <form onSubmit={handleSubmit}>
          <label style={errorLabel} htmlFor="Phone">
            <b>Phone number</b>
          </label>
          <div>
            <PhoneInput
              // isValid={(value) => {
              //   if (value.length < 12 || value.length > 15) {
              //     if (value.length >= 3 && value.length <= 11)
              //       setPhoneerror(true);
              //     return false;
              //   } else {
              //     setPhoneerror(false);
              //     return true;
              //   }
              // }}
              style={errorstyle}
              className="inputPhone"
              country={"ng"}
              value={nphone}
              onChange={setNphone}
            />
            {/* {phoneerror ? (
              <div className="error">Enter Valid Phone Number</div>
            ) : null}
            {user.error === "Invalid username or password!" && reserror === true
              ? handleResponseError()
              : ""} */}
          </div>

          <label
            style={errorLabel}
            htmlFor="Passcode"
          // style={{ marginTop: "40px" }}
          >
            Passcode
          </label>
          {/* <Input
            type="password"
            placeholder="Amount to pay from Wallet"
            className={classes.checkoutInput}
            onChange={handleWalletCode}
            value={duplicateWallet}
            disableUnderline={true}
            style={{ width: "90%", height: '100%' }}
          /> */}
          <div className="inputContainer">
            <input
              // style={errorstyle}
              className="inputForm2"
              type={!show ? "password" : "number"}
              name="Passcode"
              onChange={handleChange}
              value={values.Passcode}
              inputMode="numeric"

            />
            {show === false ?
              <img
                crossOrigin="anonymous"
                className="mask"
                src={hide}
                alt="icon"
                onClick={() => setShow(true)}
                style={{ cursor: "pointer", width: "28px", color: "#046673" }}
              />
              :
              <img
                crossOrigin="anonymous"
                className="mask"
                src={mask}
                alt="icon"
                onClick={() => setShow(false)}
                style={{ cursor: "pointer" }}
              />
            }
            {errors.Passcode ? (
              <div className="error">{errors.Passcode}</div>
            ) : null}
          </div>
          <Link className="forgetPass" to="/forgotPassword">
            Forgot Passcode
          </Link>
          <button type="submit" className="sumbitBtn">
            Login
          </button>
        </form>
        <div>&nbsp;</div>
        <Grid container>
          {/* <Grid item xs={6}>
            <FacebookLogin
              appId="2887677518113793"
              autoLoad={false}
              fields="name,email,picture"
              cssClass={classes.fb}
              textButton="&nbsp;&nbsp;&nbsp;Login"
              callback={responseFacebook}
              icon="fa-facebook"
            />
          </Grid> */}
          <Grid item xs={6}>
            <GoogleLogin
              className={classes.google}
              // style={{width:"100%"}}
              clientId="815723410350-ins2a1s6c2trpfibl0gh9nd9ts5tqtqe.apps.googleusercontent.com"
              buttonText="Login"
              onSuccess={responseGoogle}
              onFailure={responseGoogle}
              cookiePolicy={"single_host_origin"}
            />
          </Grid>
        </Grid>
        {/* <NotificationContainer /> */}
        {/* <div style={{marginLeft:"1%"}}>
                                                <FacebookLogin
                                                    appId="298623059143780"
                                                    // appId="196007421065373"
                                                    autoLoad={false}
                                                    fields="name,email,picture"
                                                    cssClass={classes.fb}
                                                    textButton="&nbsp;&nbsp;&nbsp;Login"
                                                    callback={responseFacebook}
                                                    icon="fa-facebook"
                                                />
                                                <label style={{ marginLeft: "2%", borderRadius: "5px", width: "35%" }}>
                                                    <GoogleLogin
                                                        className="GoogleLogin"
                                                        style={{width:"1000px"}}
                                                        clientId="815723410350-ins2a1s6c2trpfibl0gh9nd9ts5tqtqe.apps.googleusercontent.com"
                                                        buttonText="Login"
                                                        onSuccess={responseGoogle}
                                                        onFailure={responseGoogle}
                                                        cookiePolicy={'single_host_origin'}
                                                    />
                                                </label>
                                            </div> */}
        <div className="signup">
          Not registered yet?{" "}
          <Link to="/signup">
            <b>Create an Account</b>
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
